import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { SingleSelect } from "react-select-material-ui";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  RadioButtonGroup,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Layer,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Spinner,
  //IFrame,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Console,
  Video,
  Close,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import {
  callApiGetJson,
  callApiPostJson,
  APIServerURL,
  debugLog,
  callApiText,
  logAccess,
} from "./GlobalSettings";
import auth from "./Security/Auth";
import Iframe from "react-iframe";

class VideoHandler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadedVideoCode: false,
      myPlayer: undefined,
      VideoContent: this.props.VideoContentRecord,
    };

    this._onClose = this._onClose.bind(this);
    this.getFullScreen = this.getFullScreen.bind(this);
  }

  componentDidMount() {
    auth.verifyToken();
    logAccess(
      this.props.VideoContentRecord.Content_ID,
      this.props.VideoContentRecord.Content_Type,
      "PlayVideo",
      this.props.calledBy,
      auth.getToken()
    );
  }

  getFullScreen() {
    if (window.document.fullscreenEnabled) {
      var iFrame = window.document.getElementById("iframeVideo");
      if (iFrame.requestFullscreen) {
        iFrame.requestFullscreen();
      }
    }
  }

  _onClose() {
    this.props.hide();
  }

  render() {
    var that = this;
    debugLog(this.props.VideoContentRecord);
    var BC_PlayerURL =
      "//players.brightcove.net/5340004215001/default_default/index.html?videoId=";
    var videoURL = "";
    var videoHTML = undefined;
    var showIcons = undefined;
    var showfullscreen = undefined;
    //use Brightcove if provided
    if (this.props.VideoContentRecord.Content_BrightcoveID) {
      videoHTML = (
        <iframe
          style={{ height: "600px", width: "900px", minHeight: "600px" }}
          src={
            BC_PlayerURL + this.props.VideoContentRecord.Content_BrightcoveID
          }
          allowFullScreen
          webkitallowFullScreen
          mozAllowFullScreen
        ></iframe>
      );

      showfullscreen = <div></div>;
    } else {
      switch (this.props.UserType) {
        case "1":
          videoURL =
            this.props.VideoContentRecord.Content_EmpLink ||
            this.props.VideoContentRecord.Content_FileName ||
            this.props.VideoContentRecord.Content_Link;
          break;
        case "2":
          videoURL =
            this.props.VideoContentRecord.Content_PartnerLink ||
            this.props.VideoContentRecord.Content_FileName ||
            this.props.VideoContentRecord.Content_Link;
          break;
        default:
          videoURL =
            this.props.VideoContentRecord.Content_CustomerLink ||
            this.props.VideoContentRecord.Content_FileName ||
            this.props.VideoContentRecord.Content_Link;
          break;
      }

      videoHTML = (
        <iframe
          id={this.props.VideoContentRecord.Content_Title}
          style={{ height: "600px", width: "900px", minHeight: "600px" }}
          src={videoURL}
          allowFullScreen
          webkitallowFullScreen
          mozAllowFullScreen
        ></iframe>
      );
      showfullscreen = <div></div>;
    }

    return (
      <Layer full="false" position="center">
        {/*         <Box
          align="center"
          justify="center"
          background={{ color: "brand" }}
          fill="horizontal"
        >*/}
        <Box
          align="center"
          justify="between"
          direction="row"
          gap="medium"
          fill="horizontal"
          background={{ color: "brand" }}
        >
          <Heading size="small" level="4" margin="small">
            {this.props.VideoContentRecord.Content_Title}
          </Heading>
          <Button icon={<Close />} secondary onClick={this._onClose} />
        </Box>
        {/* </Box> */}
        <Box align="center" justify="center" flex fill>
          {videoHTML}
          {showfullscreen}
          {/* <Iframe
            url={this.state.DocumentURL}
            position="absolute"
            width="30%"
            height="30%"
            title={this.props.VideoContentRecord.Content_Title}
          /> */}
        </Box>
      </Layer>
    );
  }
}

export default VideoHandler;
